import { SET_PRINT_MODE, RESET_PRINT_MODE, PRINT_MODE_MODAL_STATUS } from './PrintModeType';

// Action to set selected print mode
export const setPrintMode = (props) => {
    return {
        type: SET_PRINT_MODE,
        selectedMode: props.selectedMode // expects a string like "Native" or "SITA FLEX"
    }
};

// Action to reset print mode
export const resetPrintMode = () => {
    return {
        type: RESET_PRINT_MODE
    }
};

export const FetchPrintModeModalStatus = (props) => {
    return{
        type: PRINT_MODE_MODAL_STATUS,
        PrintModeModalStatus: props.PrintModeModalStatus
    }
};
